import React, { useState } from "react";

export const ModelContext = React.createContext({
    inputModelData: {
        idBasicModel: 0,
        idModel: 0,
        region: "",
        cultureCode: "",
        workingFolder: ""
    },
    updateInputModelData: () => { },
    modelsData: [{
        brandName: "",
        basicModelName: "",
        idbasicModel: 0,
        modelName: "",
        modelClassification: "",
        idModel: 0,
        modelEngine: "",
        modelVersion: "",
        preliminaryData: false,
        workingFolder: ""
    }],
    updateModelsData: () => { },
});

export const ModelContextProvider = (props) => {
    const [inputModelData, setInputModelData] = useState({
        idBasicModel: 0,
        idModel: 0,
        region: "",
        cultureCode: "",
        workingFolder: ""
    });

    const [modelsData, setModelsData] = useState([{
        brandName: "",
        basicModelName: "",
        idbasicModel: 0,
        modelName: "",
        modelClassification: "",
        idModel: 0,
        modelEngine: "",
        modelVersion: "",
        preliminaryData: false,
        workingFolder: ""
    }]);

    const UpdateInputModelData = (inputModelData) => {
        setInputModelData(inputModelData);
    };

    const UpdateModelsData = (modelsData) => {
        setModelsData(modelsData);
    };

    return (
        <ModelContext.Provider value={{
            inputModelData: inputModelData,
            updateInputModelData: UpdateInputModelData,
            modelsData: modelsData,
            updateModelsData: UpdateModelsData,

        }}>
            {props.children}
        </ModelContext.Provider>
    );
};

export default ModelContext;
